export const dropdownStyles = {
  option: (provided) => ({
    ...provided,
    borderBottom: "1px dotted #1A5F7A",
    color: "#16191f",
    background: "white",
    padding: "7px 20px",
    ":hover": {
      background: "#1A5F7A",
      color: "white",
    },
  }),
  control: (provided) => ({
    ...provided,
    backgroundColor: "white",
    padding: 0,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#1A5F7A",
  }),
};
